export default {
    updateDialogsVisible(state, payload) {
        state.dialogsVisible = Object.assign({}, state.dialogsVisible, payload);
    },

    updateLoading(state, payload) {
        state.loading = Object.assign({}, state.loading, payload);
    },

    updateFormattedInactivityTime(state, payload) {
        state.formattedInactivityTime = payload;
    },

    updateFormattedLogoutTime(state, payload) {
        state.formattedLogoutTime = payload;
    },

    updateLogoutTimerVisible(state, payload) {
        state.logoutTimerVisible = payload;
    },

    stopInactivityWarningTimer(state, payload) {
        state.forceStopWarningTimer = payload;
    },

    updateNoRefresh(state, payload) {
        state.noRefresh = payload;
    },

    updateSessionExpirationTime(state, payload) {
        state.sessionExpirationTime = payload;
    },

    updateSessionTimer(state, payload) {
        state.sessionTimer = payload;
    },

    updateWarningTimer(state, payload) {
        state.warningTimer = payload;
    },
}